import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { HTTPService, HelperService, DateService, DataService } from 'app/services';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences, setLanguagePreferences } from 'app/constants/language-translate';

@Component({
  selector: 'app-set-prefrences',
  templateUrl: './set-prefrences.component.html',
  styleUrls: ['./set-prefrences.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetPrefrencesComponent implements OnInit {
  token: string = '';
  isLoading: boolean = true;
  unSubscribing: boolean = false;
  company: any = {
    name: '',
    logo: '',
    phone: '',
  };
  contact: any = {};
  year = new Date().getFullYear();
  isMarketingOptOutEnabled: boolean = false;
  emailSubscriptionFlags = {
    isMarketingNotifEnabled: false,
    isOperationalNotifEnabled: false,
  };
  data: any = {};
  currentLang: string = 'en';
  isLanguageDropdownVisible: boolean = false;
  companyLocalization: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private dataService: DataService, private httpService: HTTPService, private helperService: HelperService, private dateService: DateService, private router: Router, private translate: TranslateService) { }

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    this.companyLocalization = this.activatedRoute.snapshot.queryParamMap.get('localization') === 'true';
    if (this.companyLocalization) {
      this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
    }
    this.translate.use(this.currentLang);
    this.getData();
  }

  toggleLanguageDropdown() {
    this.isLanguageDropdownVisible = !this.isLanguageDropdownVisible;
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
    this.currentLang = lang;
    this.isLanguageDropdownVisible = false;
    setLanguagePreferences(lang, this.companyLocalization);
    this.toggleLanguageDropdown();
  }

  getData() {
    this.isLoading = true;
    this.httpService
      .getDataForUnsubscribe(this.token)
      .then(
        ({ company, contact }: any) => {
          if (environment.site && company.site && environment.site !== company.site) {
            window.location.replace(`${environment.app2_base_url}${window.location.hash}`);
            return;
          }

          this.data = {
            company: { ...company },
            contact: { ...contact },
          };

          this.company = company;

          if (company && company.appsettings && company.appsettings.isMarketingOptOutEnabled) {
            this.isMarketingOptOutEnabled = company.appsettings.isMarketingOptOutEnabled;
          }

          if (contact && contact.contactInfo) {
            this.contact = {
              contactType: contact.contactInfo.contactType,
              contactValue: contact.contactInfo.value,
              isSubscribe: contact.contactInfo.isActive,
              isMarketingNotifEnabled: contact.contactInfo.isMarketingNotifEnabled,
              isOperationalNotifEnabled: contact.contactInfo.isOperationalNotifEnabled,
            };
            this.emailSubscriptionFlags = {
              isMarketingNotifEnabled: contact.contactInfo.isMarketingNotifEnabled,
              isOperationalNotifEnabled: contact.contactInfo.isOperationalNotifEnabled,
            };
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  onSubmit() {
    this.unSubscribing = true;
    this.httpService
      .unsubscribeContact(this.token, this.emailSubscriptionFlags)
      .then(
        (res) => {
          this.helperService.openPageInSameTabAngularRoute(`save-prefrences/${this.token}`, 'set', { lang: this.currentLang, localization: this.companyLocalization });
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.unSubscribing = false;
      });
  }

  handleAppSettingChange(key: string, value: any) {
    this.emailSubscriptionFlags[key] = value;
  }
}
